import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DialogService {

  private _inputData: BehaviorSubject<any> = new BehaviorSubject(null);
  currentDialogRef: MatDialogRef<any>;

  constructor(private dialog: MatDialog) {
  }

  openDialog(component: ComponentType<any>, inputData: any = {}, options?: {
    maxWidth?: string,
    maxHeight?: string,
    height?: string,
    width?: string,
    panelClass?: string,
    autoFocus?: boolean
  }) {
    if (options) {
      this.currentDialogRef = this.dialog.open(component, {
        data: inputData,
        maxWidth: options.maxWidth,
        maxHeight: options.maxHeight,
        width: options.width,
        height: options.height,
        panelClass: options.panelClass,
        autoFocus: options.autoFocus
      });
    } else {
      this.currentDialogRef = this.dialog.open(component);
    }
    this._inputData.next(inputData);

    this.currentDialogRef.afterClosed()
      .toPromise()
      .then(() => {
        this._inputData.next(null);
      })
      .catch(() => {
        console.error('Could not clear dialog input data');
      });

    return this.currentDialogRef;
  }

  get inputData() {
    return this._inputData.getValue();
  }

  closeDialog() {
    this.currentDialogRef.close();
  }
}
